import { css } from "@emotion/react";

export const stepper = css`
  max-width: 500px;
`;
